import type { YesNoValue, YesNoAnswer, MultipleChoiceAnswer, Answer, YesNoQuestion, MultipleChoiceQuestion, Question } from '../match-server/shared-types';
import { Timestamp } from 'firebase/firestore';

export type { YesNoValue, YesNoAnswer, MultipleChoiceAnswer, Answer, YesNoQuestion, MultipleChoiceQuestion, Question };

export enum MatchPhase {
  QuestionsOnly = 1,
  WaitingForPartner = 2,
  BeaconsUnlocked = 3,
  Messaging = 4
}

export interface FlipData {
  love: number;
  habits: number;
  ambitions: number;
  spirituality: number;
  emotions: number;
}

export interface MatchDocument {
  matchedUserId: string;
  matchedUserName: string;
  createdAt: Timestamp;
  outdated: boolean;
  phase: MatchPhase;
  beaconShareRequested: boolean;
  flips?: FlipData;
  lastMessageSentAt?: Timestamp | null;
}

export enum MessageStatus {
  Draft = 'draft',
  Sent = 'sent',
  Edited = 'edited'
}

export interface MessageEditHistoryEntry {
  content: string;
  editedAt: Timestamp;
}

export interface MessageDocument {
  messageId: string;
  senderId: string;
  senderName: string;
  content: string;
  status: MessageStatus;
  createdAt: Timestamp;
  gracePeriodEndsAt: Timestamp | null;
  sentAt: Timestamp | null;
  editHistory: MessageEditHistoryEntry[];
}
